<template>
  <div style="width: 100%;">
    <v-layout row>
      <v-select
        class="sorting-field"
        style="box-shadow: none !important"
        :items="sortingOptions"
        @change="sortTable"
        d-flex
        item-text="name"
        item-value="id"
        hide-actions
        solo
        label="Сортировать по"
        hide-details
      >
        <template
          slot="selection"
          slot-scope="{ item }"
        >
          Сортировать по {{ item.name.toLowerCase() }}
        </template>
      </v-select>
      <div class="sorting-order-btn">
        <v-btn
          icon color="primary"
          @click="changeSortingOrder"
        >
          <v-icon>{{ sortingOrderIcon }}</v-icon>
        </v-btn>
      </div>
    </v-layout>
    <v-data-table
      ref="datatable"
      :headers="headers"
      :items="_itemsTableContent"
      hide-actions
      :pagination.sync="pagination"
      :loading="_tableLoading"
      style="width: 100%;"
      class="elevation-0 t-catalog-items-list"
    >
      <template slot="headerCell" slot-scope="props">
        <span>{{ props.header.value === 'tsena' && _currentDocument.name === 'schet' ? 'Цена с НДС' : props.header.text }}</span>
        <div v-if="props.header.enumeration" class="grey--text">({{ props.header.enumeration }})</div>
      </template>
      <template slot="items" slot-scope="props">
        <tr style="border-bottom: 0">
          <td colspan="4" :class="props.item.trClass" v-if="
                    !props.item.trClass ||
                    (props.item.trClass === 'rezerved' && _itemsDisplaySettings('showRezerv')) ||
                    (props.item.trClass === 'ontheway' && _itemsDisplaySettings('showTranzit')) ||
                    (props.item.trClass === 'priemka' && _itemsDisplaySettings('showPriemka'))">
            <span class="accent--text">{{ props.item.nomenklatura_id}}</span> {{ props.item.name}}
          </td>
        </tr>
        <tr :class="props.item.trClass"
            @mouseup="selectRow($event, props.item.nomenklatura_id)"
            v-if="
                    !props.item.trClass ||
                    (props.item.trClass === 'rezerved' && _itemsDisplaySettings('showRezerv')) ||
                    (props.item.trClass === 'ontheway' && _itemsDisplaySettings('showTranzit')) ||
                    (props.item.trClass === 'priemka' && _itemsDisplaySettings('showPriemka'))"
        >
          <td class="text-xs-right">{{ props.item.warranty }}</td>
          <td class="text-xs-right" v-html="props.item.tsena + (!parseInt(props.item.has_nds_rate) && _currentDocument.name === 'schet' ? '<br><span class=\'grey--text caption\'>без НДС</span>' : '')"></td>
          <td class="text-xs-right">{{ props.item.quantity }}</td>
          <td class="text-xs-right" style="text-align: right">
            <input
              @change="handleQuantity(props.item)"
              v-model.number="props.item.kolichestvo"
              @focus="$event.target.select()"
              type="number"
              min="0"
              v-numericOnly
              pattern="\d*"
              class="table-qty">
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <empty-table
          :emptyText="'Выберите папку'"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'
import emptyTable from '@/components/helpers/EmptyTable'

export default {
  name: 'CatalogItemsList',
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  components: {
    emptyTable
  },
  data () {
    return {
      pagination: {
        sortBy: 'name',
        rowsPerPage: -1,
        descending: false
      },
      sortingOptions: [
        {
          id: 'nomenklatura_id',
          name: 'Коду'
        },
        {
          id: 'name',
          name: 'Наименованию'
        },
        {
          id: 'warranty',
          name: 'Гарантии'
        },
        {
          id: 'tsena',
          name: 'Цене'
        },
        {
          id: 'quantity',
          name: 'Количеству'
        }
      ],
      selectedRowId: null,
      isLoading: false,
      headers: [
        // {
        //   text: '№',
        //   align: 'right',
        //   width: '40px',
        //   value: 'id'
        // },
        // {
        //   text: 'Наименование',
        //   width: '40px',
        //   value: 'name'
        // },
        {
          text: 'Гар.',
          enumeration: 'мес.',
          sortable: false,
          align: 'right',
          width: '40px',
          value: 'warranty'
        },
        {
          text: 'Цена',
          align: 'right',
          sortable: false,
          width: '50px',
          value: 'tsena'
        },
        {
          text: 'К-во',
          align: 'right',
          sortable: false,
          width: '50px',
          value: 'quantity'
        },
        {
          text: '',
          align: 'right',
          width: '60px',
          sortable: false,
          value: 'kolichestvo'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _itemsDisplaySettings: 'itemsDisplaySettings',
      _currentDocument: 'currentDocument',
      _tableLoading: 'tableLoading',
      _error: 'error'
    }),
    ...mapMultiRowFields('catalog', {
      _itemsTableContent: 'itemsTableContent'
    }),
    ...mapFields('catalog', {
      _showError: 'showError'
    }),
    sortingOrderIcon () {
      return this.pagination.descending ? 'mdi-arrow-up' : 'mdi-arrow-down'
    }
  },
  methods: {
    ...mapActions('catalog', {
      _addRecordToDocument: 'addRecordToDocument',
      _updateRecordToDocument: 'updateRecordToDocument',
      _beforeChangeQuantity: 'beforeChangeQuantity',
      _setError: 'setError'
    }),
    changeSortingOrder () {
      this.pagination.descending = !this.pagination.descending
    },
    sortTable (value) {
      this.pagination.sortBy = value
      // let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
      // index = (index + 1) % this.headers.length
      // index = index === 0 ? index + 1 : index
      // this.pagination.sortBy = this.headers[index].value
    },
    selectRow (e, itemId) {
      let text = ''
      if (window.getSelection) {
        text = window.getSelection().toString()
      }
      if (!text) {
        if (this.selectedRowId !== itemId) {
          this.selectedRowId = itemId
          e.target.closest('tr').querySelector('input').focus()
        }
      }
    },
    handleQuantity (item) {
      this._showError = false
      this._beforeChangeQuantity(item)
      if (this._error) {
        this._showError = true
        item.kolichestvo = ''
        return false
      } else {
        this._setError(false)
      }

      let record = this._currentDocument.records.find(function (obj) {
        return obj.nomenklatura_id === item.nomenklatura_id
      })
      if (record) {
        this._updateRecordToDocument({
          nomenklatura_id: item.nomenklatura_id,
          kolichestvo: item.kolichestvo,
          name: item.name,
          warranty: item.warranty,
          tsena: item.tsena,
          st: item.st
        })
      } else {
        this._addRecordToDocument({
          nomenklatura_id: item.nomenklatura_id,
          kolichestvo: item.kolichestvo,
          name: item.name,
          warranty: item.warranty,
          tsena: item.tsena,
          st: item.st
        })
      }
    }
  }
}
</script>

<style lang="stylus">
  .sorting-field {
    border-width: 0 1px 1px 0
    border-color #ccc
    border-style solid
    .v-input__slot {
      border-radius 0 !important
      box-shadow none !important
    }
  }
    .sorting-order-btn {
      border-width: 0 0 1px 0
      border-color #ccc
      border-style solid
    }

  .t-catalog-items-list {
    .column {
      padding-left 16px !important
      padding-right 16px !important
    }

    tbody td {
      padding-left 16px !important
      padding-right 16px !important
    }
  }

  .table-qty {
    border: 1px solid rgba(0, 0, 0, 0.12);
    width: 50px;
    margin: 0;
    text-align: right;
    padding: 5px;
    outline: none;
  }

  .rezerved {
    color: red;
  }

  .ontheway {
    color: blue;
  }

  .priemka {
    color: purple;
  }
</style>
